/*
  Review flow, "Get it fixed" dialog (snippets/bw-review-fix.liquid, assets/bw-review-fix.css).

  Contract with assets/bw-review-modal.js:
  - It dispatches 'bw:get-it-fixed' on document with detail
    { rating, productHandle, productTitle, productUrl, source, handled }. We set detail.handled = true
    synchronously and open the dialog above Judge.me's modal.
  - window.BWReviewModal.close() closes Judge.me's modal (X, Escape and Done close both).
  - window.bwTrack(name, props) comes from snippets/bw-review-capture.liquid.

  Sending: Shopify's contact form, so customer care gets it at the store's contact address.
  Shopify's bot protection (inline bootstrap in content_for_header + storefront-forms-hcaptcha) binds any
  form[action*='/contact'] with form_type=contact on its first focusin/change. Binding keeps the form's own
  submit() (if it has one) and replaces it with: run invisible hCaptcha, add h-captcha-response and
  form_key, then call that original submit(). So we give the form our own submit() (fetch) before that
  happens and always send through form.submit(): with hCaptcha on, the token is added before our fetch runs.
  If Shopify still answers with a challenge (or anything but contact_posted=true), we fall back to the
  native submit so the customer can finish the challenge; a sessionStorage flag lets the next page load
  show the confirmation when it comes back with contact_posted=true.
*/
(() => {
  'use strict';

  const root = document.getElementById('bw-fix');
  const form = document.getElementById('bw-fix-form');
  if (!root || !form) return;

  const CTX_KEY = 'bw_review_ctx';
  const PENDING_KEY = 'bw_fix_pending';
  const PENDING_TTL = 60 * 60 * 1000;
  const RESOLVABLE = ['dislike', 'damaged', 'missing'];
  const FRAUNCES = 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght,SOFT,WONK@0,9..144,700,0..100,0..1;1,9..144,700,0..100,0..1&display=swap';
  const STAR = '<svg viewBox="0 1 48 46" aria-hidden="true" focusable="false"><path d="M20.5649 4.88026C21.6748 1.59227 26.3252 1.59227 27.4351 4.88025L30.457 13.8321C30.9545 15.3058 32.3366 16.2981 33.892 16.2981H43.3676C46.9132 16.2981 48.351 20.8628 45.4454 22.8948L38.0206 28.0872C36.7011 29.0099 36.1483 30.6923 36.6633 32.2178L39.5549 40.7842C40.6743 44.1004 36.9102 46.9207 34.042 44.9149L26.0778 39.3452C24.83 38.4727 23.17 38.4727 21.9222 39.3452L13.958 44.9149C11.0898 46.9207 7.32566 44.1004 8.44504 40.7842L11.3367 32.2178C11.8517 30.6923 11.2989 29.0099 9.97941 28.0872L2.55461 22.8948C-0.35096 20.8628 1.08682 16.2981 4.6324 16.2981H14.108C15.6634 16.2981 17.0455 15.3058 17.543 13.8321L20.5649 4.88026Z"/></svg>';

  const $ = (sel, scope = root) => scope.querySelector(sel);
  const $$ = (sel, scope = root) => Array.from(scope.querySelectorAll(sel));
  const card = $('.bw-fix__card');
  const done = $('[data-bw-fix-done]');
  const issueGroup = $('#bw-fix-issue');
  const resGroup = $('#bw-fix-res');
  const resWrap = $('[data-bw-fix-res-wrap]');
  const more = $('#bw-fix-more');
  const email = $('#bw-fix-email');
  const orderInput = $('#bw-fix-order');
  const submitBtn = $('button[type="submit"]', form);
  const prefilledEmail = email.value;

  const track = (name, props) => { try { if (window.bwTrack) window.bwTrack(name, props); } catch (e) { /* never break the flow */ } };
  const store = {
    get(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ } },
    remove(key) { try { sessionStorage.removeItem(key); } catch (e) { /* private mode */ } }
  };
  const handleOf = (url) => {
    try { return new URL(url, location.origin).pathname.split('/').filter(Boolean).pop() || ''; } catch (e) { return ''; }
  };
  const productPage = (handle) => location.origin + '/products/' + handle;
  const maskEmail = (value) => value.replace(/^(.)[^@]*/, '$1****');
  const validEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const orderLabel = (order) => (String(order).charAt(0) === '#' ? order : '#' + order);

  /* Fraunces for the titles, loaded only for visitors who come from the review flow. */
  function loadTitleFont() {
    if (document.querySelector('link[href*="family=Fraunces"]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FRAUNCES;
    document.head.appendChild(link);
  }

  /* ---------- State ---------- */
  const state = {
    open: false,
    phase: 'idle', // idle | sending | done
    product: null, // { handle, title, url, rating }
    ctx: null,
    others: Promise.resolve([]),
    opener: null,
    judgeme: null,
    judgemeInert: false
  };

  /* Other products of the order: stored items minus the current product and the ones already handled,
     deduped by handle, with title and image from /products/<handle>.js. */
  function loadOthers(ctx, currentHandle) {
    const skip = new Set([currentHandle].concat((ctx && ctx.done) || []));
    const seen = new Set();
    const items = ((ctx && ctx.items) || []).filter((url) => {
      const handle = handleOf(url);
      if (!handle || skip.has(handle) || seen.has(handle)) return false;
      seen.add(handle);
      return true;
    });
    const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return Promise.all(items.map((url) => {
      const handle = handleOf(url);
      return fetch(shopRoot + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then((res) => (res.ok ? res.json() : null))
        .then((p) => (p && p.title ? { url, handle, title: p.title, image: p.featured_image || '' } : null))
        .catch(() => null);
    })).then((list) => list.filter(Boolean));
  }

  /* Visitors from the review email are not logged in, but Judge.me knows their email from the review link. It
     fills its own field after loading the link's data, which can land after our dialog opens, so we keep checking
     for a few seconds. Never overwrites a value: stops once the customer types or the field has one. */
  let emailWatch = 0;
  let emailTouched = false;
  function copyJudgemeEmail() {
    if (emailTouched || email.value) return true;
    const jmEmail = document.getElementById('jdgm-email-input');
    const value = jmEmail ? jmEmail.value.trim() : '';
    if (!validEmail(value)) return false;
    email.value = value;
    setError('bw-fix-email-error', false, email);
    return true;
  }
  function watchJudgemeEmail() {
    clearInterval(emailWatch);
    emailTouched = false;
    if (copyJudgemeEmail()) return;
    let tries = 0;
    emailWatch = setInterval(() => {
      if (!state.open || copyJudgemeEmail() || ++tries >= 40) clearInterval(emailWatch);
    }, 250);
  }

  /* ---------- Open / close ---------- */
  function resetForm() {
    form.reset();
    email.value = prefilledEmail;
    resWrap.hidden = true;
    $$('.bw-fix__error').forEach((el) => { el.hidden = true; });
    issueGroup.classList.remove('is-invalid');
    [more, email].forEach((el) => { el.classList.remove('is-invalid'); el.removeAttribute('aria-invalid'); });
    form.removeAttribute('aria-busy');
    state.phase = 'idle';
  }

  function showScreen(name) {
    form.hidden = name !== 'form';
    done.hidden = name !== 'done';
    const title = name === 'form' ? $('#bw-fix-title') : $('#bw-fix-done-title');
    card.setAttribute('aria-labelledby', title.id);
    $('.bw-fix__layer').scrollTop = 0;
    requestAnimationFrame(() => title.focus({ preventScroll: true }));
  }

  function show() {
    loadTitleFont();
    if (state.open) return; // already open: keep the first opener and Judge.me's own inert value
    state.opener = document.activeElement;
    state.judgeme = document.querySelector('.jdgm-write-review-modal');
    if (state.judgeme) { state.judgemeInert = state.judgeme.inert; state.judgeme.inert = true; }
    root.hidden = false;
    document.documentElement.classList.add('bw-fix-open');
    state.open = true;
  }

  function hide() {
    root.hidden = true;
    document.documentElement.classList.remove('bw-fix-open');
    if (state.judgeme) { state.judgeme.inert = state.judgemeInert; state.judgeme = null; }
    state.open = false;
  }

  function open(detail) {
    const handle = detail.productHandle || handleOf(detail.productUrl || location.pathname);
    state.product = {
      handle,
      title: detail.productTitle || handle,
      url: productPage(handle),
      rating: Number(detail.rating) || null
    };
    state.ctx = store.get(CTX_KEY);
    state.others = loadOthers(state.ctx, handle);
    resetForm();
    watchJudgemeEmail();

    const order = state.ctx && state.ctx.order;
    $('[data-bw-fix-chip]').hidden = !order;
    $('[data-bw-fix-order-field]').hidden = !!order;
    if (order) $('[data-bw-fix-order]').textContent = 'Order ' + orderLabel(order);

    show();
    showScreen('form');
    track('Review Help Form Opened', { rating: state.product.rating, product: handle, source: detail.source || '' });
  }

  /* Back: only our dialog closes; Judge.me's help screen is still underneath. */
  function closeOwn() {
    hide();
    const opener = state.opener;
    state.opener = null;
    if (opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
  }

  /* X, Escape and Done: close both. Judge.me restores focus to what opened its modal. */
  function closeAll() {
    const canCloseJudgeme = window.BWReviewModal && typeof window.BWReviewModal.close === 'function';
    if (!canCloseJudgeme) { closeOwn(); return; }
    hide();
    state.opener = null;
    try { window.BWReviewModal.close(); } catch (e) { /* the modal may be gone already */ }
  }

  /* ---------- Validation ---------- */
  function setError(errorId, invalid, field) {
    $('#' + errorId).hidden = !invalid;
    if (!field) return;
    field.classList.toggle('is-invalid', invalid);
    if (invalid) field.setAttribute('aria-invalid', 'true'); else field.removeAttribute('aria-invalid');
  }

  function values() {
    const issue = form.querySelector('input[name="bw_issue"]:checked');
    const res = form.querySelector('input[name="bw_resolution"]:checked');
    return {
      issue: issue ? issue.value : '',
      issueLabel: issue ? issue.closest('label').textContent.trim() : '',
      resolution: res ? res.value : '',
      note: more.value.trim(),
      email: email.value.trim(),
      orderTyped: orderInput.value.trim()
    };
  }

  /* Same rules as the prototype: issue required; the note is required once an issue is picked; the
     resolution only for dislike, damaged and missing; plus a valid email. */
  function validate(v) {
    const badIssue = !v.issue;
    const badNote = !!v.issue && !v.note;
    const badRes = RESOLVABLE.includes(v.issue) && !v.resolution;
    const badEmail = !validEmail(v.email);
    issueGroup.classList.toggle('is-invalid', badIssue);
    setError('bw-fix-issue-error', badIssue);
    setError('bw-fix-more-error', badNote, more);
    setError('bw-fix-res-error', badRes);
    setError('bw-fix-email-error', badEmail, email);
    const first = badIssue ? issueGroup : badNote ? more : badRes ? resGroup : badEmail ? email : null;
    if (first) {
      first.scrollIntoView({ block: 'center' });
      (first.matches('input, textarea') ? first : first.querySelector('input')).focus({ preventScroll: true });
      return false;
    }
    return true;
  }

  form.addEventListener('change', (e) => {
    if (e.target.name === 'bw_issue') {
      issueGroup.classList.remove('is-invalid');
      setError('bw-fix-issue-error', false);
      setError('bw-fix-more-error', false, more);
      const showRes = RESOLVABLE.includes(e.target.value);
      resWrap.hidden = !showRes;
      if (!showRes) $$('input[name="bw_resolution"]', form).forEach((el) => { el.checked = false; });
    }
    if (e.target.name === 'bw_resolution') setError('bw-fix-res-error', false);
  });
  more.addEventListener('input', () => setError('bw-fix-more-error', false, more));
  email.addEventListener('input', () => { emailTouched = true; });
  email.addEventListener('input', () => { if (validEmail(email.value.trim())) setError('bw-fix-email-error', false, email); });

  /* ---------- Sending ---------- */
  function fillContactFields(v, others) {
    const p = state.product;
    const order = (state.ctx && state.ctx.order) || v.orderTyped;
    const set = (name, value) => { form.elements['contact[' + name + ']'].value = value; };
    const fields = [
      ['Order', order ? orderLabel(order) : 'Not provided'],
      ['Product', p.title],
      ['Product page', p.url],
      ['Rating', p.rating ? p.rating + ' of 5 stars' : 'Not given'],
      ['Issue', v.issueLabel],
      ['Resolution', v.resolution || 'Not asked for this issue'],
      ['Other products in order', others.length ? others.map((o) => o.title).join(', ') : 'None']
    ];
    fields.forEach(([name, value]) => set(name, value));
    set('body', ['Get it fixed (review flow)']
      .concat(fields.map(([name, value]) => name + ': ' + value))
      .concat(['', 'What happened:', v.note])
      .join('\n'));
  }

  function success(pending) {
    state.phase = 'done';
    form.removeAttribute('aria-busy');
    store.remove(PENDING_KEY);
    const formKey = form.elements.form_key;
    if (formKey && formKey.value) store.remove(formKey.value); // Shopify's copy of the fields, kept for its challenge page
    const ctx = store.get(CTX_KEY);
    if (ctx) {
      ctx.done = Array.from(new Set((ctx.done || []).concat(pending.product)));
      store.set(CTX_KEY, ctx);
    }
    track('Review Help Submitted', { issue: pending.issue, resolution: pending.resolution || null, rating: pending.rating, product: pending.product });
    showDone(pending, state.others);
  }

  function fallback(reason) {
    track('Review Help Submit Failed', { reason });
    HTMLFormElement.prototype.submit.call(form);
  }

  /* Our submit(). Shopify's hCaptcha binding calls it after adding its token. */
  async function send() {
    if (state.phase !== 'idle') return;
    state.phase = 'sending';
    const pending = store.get(PENDING_KEY);
    let res;
    try {
      res = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
    } catch (e) {
      fallback('network');
      return;
    }
    const finalUrl = res.url || '';
    if (/[?&]contact_posted=true/.test(finalUrl)) success(pending);
    else fallback(/\/challenge/.test(finalUrl) ? 'challenge' : 'unexpected_response_' + res.status);
  }
  form.submit = send;

  form.addEventListener('submit', async (e) => {
    // Ours alone: Shopify's own listeners would submit without our checks.
    e.preventDefault();
    e.stopImmediatePropagation();
    if (state.phase === 'done') return;
    const v = values();
    if (!validate(v)) return;
    form.setAttribute('aria-busy', 'true');
    const others = await state.others;
    fillContactFields(v, others);
    store.set(PENDING_KEY, {
      ts: Date.now(),
      email: v.email,
      resolution: v.resolution,
      issue: v.issue,
      rating: state.product.rating,
      product: state.product.handle,
      title: state.product.title
    });
    form.submit();
  });

  /* ---------- Confirmation ---------- */
  function renderRows(list) {
    const rows = $('[data-bw-fix-rows]');
    rows.textContent = '';
    list.forEach((item, i) => {
      const li = document.createElement('li');
      li.className = 'bw-fix__row';
      if (item.image) {
        const img = document.createElement('img');
        img.className = 'bw-fix__row-img';
        img.alt = '';
        img.width = 88;
        img.height = 88;
        img.src = item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=176';
        li.appendChild(img);
      }
      const text = document.createElement('div');
      text.className = 'bw-fix__row-text';
      const title = document.createElement('p');
      title.className = 'bw-fix__row-title';
      title.id = 'bw-fix-row-' + i;
      title.textContent = item.title;
      const stars = document.createElement('div');
      stars.className = 'bw-fix__stars';
      stars.setAttribute('role', 'group');
      stars.setAttribute('aria-labelledby', title.id);
      for (let n = 1; n <= 5; n++) {
        const a = document.createElement('a');
        a.className = 'bw-fix__star';
        a.href = item.url + (item.url.indexOf('?') === -1 ? '?' : '&') + 'judgeme_rating=' + n;
        a.dataset.rating = String(n);
        a.dataset.product = item.handle;
        a.setAttribute('aria-label', n === 1 ? '1 star' : n + ' stars');
        a.innerHTML = STAR;
        stars.appendChild(a);
      }
      text.append(title, stars);
      li.appendChild(text);
      rows.appendChild(li);
    });
    $('[data-bw-fix-rest]').hidden = list.length === 0;
  }

  function showDone(pending, othersPromise) {
    const masked = maskEmail(pending.email || '');
    $$('[data-bw-fix-masked]').forEach((el) => { el.textContent = masked; });
    $('[data-bw-fix-variant="resolution"]').hidden = !pending.resolution;
    $('[data-bw-fix-variant="reach"]').hidden = !!pending.resolution;
    $('[data-bw-fix-rest]').hidden = true;
    showScreen('done');
    othersPromise.then(renderRows);
  }

  const paint = (stars, n, cls) => stars.forEach((s, i) => s.classList.toggle(cls, i < n));
  root.addEventListener('mouseover', (e) => {
    const star = e.target.closest('.bw-fix__star');
    if (star) paint(Array.from(star.parentElement.children), Number(star.dataset.rating), 'is-prev');
  });
  root.addEventListener('mouseout', (e) => {
    const star = e.target.closest('.bw-fix__star');
    if (star && !star.parentElement.contains(e.relatedTarget)) paint(Array.from(star.parentElement.children), 0, 'is-prev');
  });

  root.addEventListener('click', (e) => {
    const star = e.target.closest('.bw-fix__star');
    if (star) {
      track('Review Help Other Product Star Clicked', { rating: Number(star.dataset.rating), product: star.dataset.product });
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      paint(Array.from(star.parentElement.children), Number(star.dataset.rating), 'is-on');
      setTimeout(() => { location.href = star.href; }, 250);
      return;
    }
    if (e.target.closest('[data-bw-fix-close], [data-bw-fix-finish]')) { closeAll(); return; }
    if (e.target.closest('[data-bw-fix-back]')) closeOwn();
  });

  /* ---------- Keyboard: Escape like X, Tab stays inside. Runs before Judge.me's document listener
     (Escape would close its modal, Tab would pull focus into it). ---------- */
  /* First stop is the X, last stop is the screen's main button (Submit or Done). */
  function edges() {
    const last = form.hidden ? $('[data-bw-fix-finish]') : submitBtn;
    return [$('[data-bw-fix-close]'), last];
  }
  window.addEventListener('keydown', (e) => {
    if (!state.open) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      closeAll();
      return;
    }
    if (e.key !== 'Tab') return;
    e.stopPropagation();
    const [first, last] = edges();
    const active = document.activeElement;
    if (!card.contains(active)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); return; }
    if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }, true);

  /* ---------- Entry points ---------- */
  document.addEventListener('bw:get-it-fixed', (e) => {
    if (!e.detail || typeof e.detail !== 'object') return;
    e.detail.handled = true;
    open(e.detail);
  });

  window.BWReviewFix = { open: (detail) => open(detail || {}), close: closeOwn };

  const params = new URLSearchParams(location.search);
  if (store.get(CTX_KEY) || params.has('judgeme_rating')) loadTitleFont();

  /* Back from Shopify's challenge page: the request went through, show the confirmation. */
  const pending = store.get(PENDING_KEY);
  if (pending && params.get('contact_posted') === 'true' && Date.now() - (pending.ts || 0) < PENDING_TTL) {
    state.ctx = store.get(CTX_KEY);
    state.product = { handle: pending.product, title: pending.title, url: productPage(pending.product), rating: pending.rating };
    state.others = loadOthers(state.ctx, pending.product);
    show();
    success(pending);
  }

  /* QA hook: ?bw_fix_test=1 opens the dialog for the current product after load. */
  if (params.get('bw_fix_test') === '1') {
    const run = () => {
      const handle = handleOf(location.pathname);
      const meta = document.querySelector('meta[property="og:title"]');
      const detail = {
        rating: Number(params.get('judgeme_rating')) || 2,
        productHandle: handle,
        productTitle: meta ? meta.content : document.title,
        productUrl: productPage(handle),
        source: 'qa-test',
        handled: false
      };
      document.dispatchEvent(new CustomEvent('bw:get-it-fixed', { detail }));
    };
    if (document.readyState === 'complete') setTimeout(run, 0); else window.addEventListener('load', () => setTimeout(run, 0));
  }
})();
